import React from 'react';

import { useModalObject } from '@front/common/src/hooks/use-modal';

import WhatIsTaxCreditModal from './what-is-tax-credit-modal';
import WhatIsInstantTaxCreditModal from './what-is-instant-tax-credit-modal';

export const useWhatIsTaxCreditModals = () => {
  const {
    close: closeWhatIsInstantTaxCreditModal,
    isOpen: isWhatIsInstantTaxCreditModalOpen,
    open: openWhatIsInstantTaxCreditModal,
  } = useModalObject();

  const {
    close: closeWhatIsTaxCreditModal,
    isOpen: isWhatIsTaxCreditModalOpen,
    open: openWhatIsTaxCreditModal,
  } = useModalObject();

  const whatIsTaxCreditModals = (
    <>
      <WhatIsInstantTaxCreditModal
        isOpen={isWhatIsInstantTaxCreditModalOpen}
        onClose={closeWhatIsInstantTaxCreditModal}
      />
      <WhatIsTaxCreditModal isOpen={isWhatIsTaxCreditModalOpen} onClose={closeWhatIsTaxCreditModal} />
    </>
  );

  return {
    openWhatIsInstantTaxCreditModal,
    openWhatIsTaxCreditModal,
    whatIsTaxCreditModals,
  };
};
